var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6287 1.37298C16.798 -0.457652 13.8302 -0.457652 11.9995 1.37294L8.08178 5.29067C6.18823 7.18431 6.36354 10.2015 8.08178 11.9198C8.36952 12.2076 8.68788 12.4422 9.02405 12.6349L9.73909 11.9198C10.2081 11.4508 10.043 10.9024 10.0346 10.5068C9.93163 10.4338 9.83151 10.3549 9.73909 10.2625C8.85733 9.38083 8.81768 7.86935 9.73909 6.94794C9.87593 6.81111 13.5737 3.11333 13.6568 3.03028C14.5708 2.11626 16.0573 2.11626 16.9713 3.03028C17.8853 3.94431 17.8853 5.43083 16.9713 6.34485L14.3818 8.93443C14.4566 9.34876 14.906 10.3302 14.6749 11.9493C14.6862 11.9382 14.6997 11.9311 14.7109 11.9199L18.6287 8.00212C20.4592 6.1715 20.4592 3.2036 18.6287 1.37298Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2234 7.77656C11.9357 7.48883 11.6173 7.25422 11.2812 7.06152L10.5661 7.77656C10.0971 8.24555 10.2621 8.79387 10.2706 9.18953C10.3736 9.2625 10.4737 9.34137 10.5661 9.43379C11.4479 10.3156 11.4875 11.827 10.5661 12.7484C10.429 12.8855 6.42491 16.8896 6.34479 16.9697C5.43077 17.8837 3.94424 17.8837 3.03022 16.9697C2.11619 16.0557 2.11619 14.5691 3.03022 13.6551L5.92346 10.7619C5.84858 10.3475 5.39913 9.36606 5.63034 7.74699C5.61905 7.75809 5.60546 7.76531 5.59421 7.77652L1.37291 11.9979C-0.457637 13.8285 -0.457637 16.7964 1.37291 18.627C3.20354 20.4576 6.17139 20.4576 8.00202 18.627L12.2234 14.4057C14.0818 12.5473 13.9802 9.5334 12.2234 7.77656Z",
    fill: "#2C3E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlue);
export default __webpack_public_path__ + "static/media/link-blue.852a4519530f1cdf00d6ca7ae6bc565e.svg";
export { ForwardRef as ReactComponent };